const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedCasinoTagCategory: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const casinotagcategory = (state = initialState, action) => {
	switch (action.type) {
		case 'CASINOTAGCATEGORY_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'CASINOTAGCATEGORY_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'CASINOTAGCATEGORY_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'CASINOTAGCATEGORY_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'CASINOTAGCATEGORY_GET_CURRENT':
			return {
				...state,
				selectedCasinoTagCategory: action.selectedCasinoTagCategory,
			}
		case 'CASINOTAGCATEGORY_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default casinotagcategory
